import { Button } from "antd";
import {
  SaveOutlined,
  CloseOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownFromBracket, faArrowUpFromBracket, faMagnifyingGlass, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { faFilterSlash, faFloppyDisk, faTrash, faXmark } from "@fortawesome/pro-regular-svg-icons";

const VARIANTS = {
  save: {
    type: "primary",
    icon: <FontAwesomeIcon icon={faFloppyDisk} />,
    className: "bg-[#01A4A6]",
  },
  close: {
    type: "default",
    icon: <FontAwesomeIcon icon={faXmark} />,
    className: "bg-white text-[#01A4A6] border border-[#01A4A6]",
  },
  delete: {
    type: "primary",
    danger: false,
    icon: <FontAwesomeIcon icon={faTrash} />,
    className: "bg-[#789B9E]",
  },
  new: {
    type: "primary",
    icon: <FontAwesomeIcon icon={faPlus} />,
    className: "bg-[#01A4A6]",
  },
  search: {
    type: "primary",
    icon: <FontAwesomeIcon icon={faMagnifyingGlass} />,
    className: "bg-[#01A4A6]",
  },
  clearFilter: {
    type: "default",
    icon: <FontAwesomeIcon icon={faFilterSlash} />,
    className: "bg-white text-[#01A4A6] border border-[#01A4A6]",
  },
  export: {
    type: "primary",
    icon: <FontAwesomeIcon icon={faArrowDownFromBracket} />,
    className: "bg-[#01A4A6]",
  },
  import: {
    type: "primary",
    icon: <FontAwesomeIcon icon={faArrowUpFromBracket} />,
    className: "bg-[#01A4A6]",
  },
};

const AppButton = ({
  variant = "save",
  className,
  children,
  ...props
}) => {
  const v = VARIANTS[variant];

  return (
    <Button
      {...props}
      type={v.type}
      danger={v.danger}
      icon={v.icon}
      className={clsx(
        "font-bold ml-2 py-4 rounded-lg min-w-24 shadow-md",
        v.className,
        className
      )}
    >
      {children}
    </Button>
  );
};

export default AppButton;
